import { Box } from "@dealer-center/core-components";
import type { DealerAndId } from "./helper";
import { treeItemStyles } from "./treeStyles";
export const dealerPropertiesToDisplay = [
  {
    label: "ID",
    key: "id"
  },
  {
    label: "Phone",
    key: "phone"
  },
  {
    label: "Email",
    key: "email"
  },
  {
    label: "URL",
    key: "url"
  },
  {
    label: "Status",
    key: "status"
  }
];

export const TreeItemAdditionalInfo = (props: {
  dealer: DealerAndId;
  label: string;
}) => {
  return dealerPropertiesToDisplay.map(property => {
    const value = props.dealer[property.key as keyof DealerAndId];

    return (
      <Box key={property.key} sx={treeItemStyles.itemDetailsItemSX}>
        <Box sx={treeItemStyles.itemDetailsValueSX}>
          {typeof value === "string" ? (value ? value : "---") : "---"}
        </Box>
      </Box>
    );
  });
};
